import React from "react";
import JarvisButton from "components/JarvisButton";
import Box from "./Box";
import Text from "./Text";
import { useSelector } from "react-redux";
import { usePhcTheme } from "pages/PHC/Dashboard/PhcThemeContext";
import { getPhcGlassCardSx } from "pages/PHC/Dashboard/phcThemes";

const BlurWrapper = ({ blur, children }) => {
  const { theme, mode } = usePhcTheme();
  const naviaSignupUrl = useSelector(
    (state) => state.PHC?.PHCOnboarding?.redirectUrl,
  );

  if (!blur) return children || null;

  return (
    <Box
      sx={{
        textAlign: "center",
        width: "100%",
        maxWidth: "100%",
        px: 1.5,
        py: 1.75,
        ...getPhcGlassCardSx(mode),
      }}
    >
      <Text
        sx={{
          mb: 1.5,
          fontWeight: 600,
          fontSize: { xs: "12px", sm: "16px" },
          color: theme.textPrimary,
          lineHeight: 1.35,
        }}
      >
        Sign in to Navia to unlock full report
      </Text>

      <JarvisButton
        fullWidth
        disabled={!naviaSignupUrl}
        sx={{ minHeight: { xs: 36, sm: 42 } }}
        onClick={() => {
          if (naviaSignupUrl) {
            window.location.href = naviaSignupUrl;
          }
        }}
      >
        Sign in
      </JarvisButton>
    </Box>
  );
};

export default BlurWrapper;
